import { ProductUi, SellerLineUi } from '@/components/Cart/modal/CartUiModel';
import { CreateEditCartUi } from '@/components/Cart/modal/CreateEdit/CreateEditUiModel';
import {
  CreateCartRequest,
  DeliveryInfoRequest,
  ProductRequest,
} from '@/data/api/model/cart/CartDto';

export function createCartRequestFromUiModel(
  input: CreateEditCartUi
): CreateCartRequest {
  const ret: CreateCartRequest = {
    cart_name: input.cartTitle,
    buyer_business_id: input.buyer?.id ?? '',
    products: input.products.map(uiProductToProductRequest),
    delivery: input.sellers.map(uiSellerToDeliveryInfoRequest),
  };
  return ret;
}

function uiProductToProductRequest(productUi: ProductUi): ProductRequest {
  return {
    product_id: productUi.id,
    sku_id: productUi.skuId,
    quantity: productUi.quantity,
    price: Number(productUi.customPricing),
  };
}

function uiSellerToDeliveryInfoRequest(
  sellerUi: SellerLineUi
): DeliveryInfoRequest {
  return {
    seller_business_id: sellerUi.id,
    delivery_date: sellerUi.deliveryDate?.format('DD-MM-YYYY') ?? undefined,
    delivery_time: sellerUi.deliveryStartTime?.format('HH:mm') ?? undefined,
    delivery_time_end: sellerUi.deliveryEndTime?.format('HH:mm') ?? undefined,
    delivery_notes: sellerUi.deliveryNotes,
  };
}
